module.exports = __webpack_public_path__ + "static/media/oliveira-hospital-1.b022abd5.jpg";